const { getElement } = window.BAO.Utils

class ProductDetail extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()
    this.cloneContent()
  }

  setupListeners () {
    super.setupListeners()

    this.onScroll = this.onScroll.bind(this)

    window.addEventListener('scroll', this.onScroll, { passive: true })
  }

  cloneContent () {
    if (!this.els?.clone?.exists) return
    this.els.clone.elements.forEach(cloneEl => {
      if (!cloneEl.dataset?.cloneIdentifier) return

      const elementToClone = getElement(cloneEl.dataset.cloneIdentifier, {
        context: this,
      })
      if (!elementToClone) return
      cloneEl.innerHTML = elementToClone.innerHTML
    })
  }

  onScroll () {
    this.lastKnownY = window.scrollY
    const stickyEl = document.querySelector('.prd-Detail_Blocks-sticky')
    if (this.lastKnownY >= 400) {
      stickyEl.classList.add('prd-Detail_Blocks-stickyScrolled')
    } else {
      stickyEl.classList.remove('prd-Detail_Blocks-stickyScrolled')
    }
  }
}

if (!customElements.get('product-detail')) {
  customElements.define('product-detail', ProductDetail)
}
